import {decodeCloudQueueActionString} from '../cloud-queue-encode-decode.js'
import store from '../../init/store.js'

export function isCloudActionRelevant(turnQueueString) {

  if (!turnQueueString.match(/cloudQueueAction/)) {
    //Assume this move is relevant if it's not from the cloudQueue
    return true
  }

  //Get actionModel, casterModel, and targetModels
  const cloudSubmission = decodeCloudQueueActionString(
    turnQueueString,
    store.getState().battle.combatants
  );

  //Case 1: Natural status heal:
  // Validate that the target is still suffering from the oncoming natural heal
  if (cloudSubmission.actionModel.affectTargetStatus) {
    const targetModel = cloudSubmission.targetModels[0]; //Assume only 1 target for natural recoveries.

    const naturalRecoveringStatus = cloudSubmission.actionModel.affectTargetStatus[0];

    if (targetModel.status !== naturalRecoveringStatus) {
      // console.log('IRRELEVANT CLOUD RECOVERY');
      return false;
    }
  }

  //Case 2: This combatant is dead! Who woulda thunk!


  return true;
}


// WEBPACK FOOTER //
// ./src/battle/lifecycle/is-cloud-action-relevant.js